export const BADGE_DETAIL_URL = "/cryptobadge/badge";
export const CERTIFICATE_DETAIL_URL = "/cryptobadge/certificate";
